const NotFound = () => (
  <div>Sorry, nothing here.</div>
)

export default NotFound;